import { render } from "./ProcessoPrazosComponent.vue?vue&type=template&id=0f14396a&scoped=true"
import script from "./ProcessoPrazosComponent.vue?vue&type=script&lang=js"
export * from "./ProcessoPrazosComponent.vue?vue&type=script&lang=js"

import "./ProcessoPrazosComponent.vue?vue&type=style&index=0&id=0f14396a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f14396a"]])

export default __exports__